import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../actions/button/button';
import { Modal, ModalControlProps } from '../modal';

type AreYouStillThereProps = {
	onContinue: () => void;
	onEnd: () => void;
} & Omit<ModalControlProps, 'onOpenChange'>;

export const AreYouStillThere = ({ open, onContinue, onEnd }: AreYouStillThereProps) => {
	const { t } = useTranslation();
	return (
		<Modal open={open} onOpenChange={null}>
			<Modal.Header>{t('checkout.modals.session_expired.title')}</Modal.Header>

			<Modal.Body>
				<p>{t('checkout.modals.session_expired.description1')}</p>
				<p>{t('checkout.modals.session_expired.description2')}</p>
			</Modal.Body>

			<Modal.Footer>
				<Button fullWidth variant='secondary' onClick={onContinue}>
					{t('checkout.modals.session_expired.resume_button')}
				</Button>
				<Button fullWidth variant='tertiary' onClick={onEnd}>
					{t('checkout.modals.session_expired.end_button')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
